class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      if (typeof window._cthCheckMilestoneGift === 'function') {
        window._cthCheckMilestoneGift();
      }
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if (typeof window._cthCheckMilestoneGift === 'function') {
        window._cthCheckMilestoneGift(parsedState);
      }
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

let isMilestoneGiftSyncing = false;

function getMilestoneGiftConfig() {
  let enabled = true;
  let giftVariantId = 67489383940386;
  let giftThreshold = 199900;
  let discountCode1 = 'Rs 50 OFF';
  let discountCode2 = 'Rs 100 OFF';

  if (window.themeMilestoneConfig) {
    if (typeof window.themeMilestoneConfig.enabled !== 'undefined') {
      enabled = Boolean(window.themeMilestoneConfig.enabled);
    }
    if (window.themeMilestoneConfig.giftVariantId) {
      giftVariantId = Number(window.themeMilestoneConfig.giftVariantId);
    }
    if (window.themeMilestoneConfig.threshold4) {
      giftThreshold = Number(window.themeMilestoneConfig.threshold4);
    }
    if (window.themeMilestoneConfig.discountCode1) {
      discountCode1 = String(window.themeMilestoneConfig.discountCode1);
    }
    if (window.themeMilestoneConfig.discountCode2) {
      discountCode2 = String(window.themeMilestoneConfig.discountCode2);
    }
  }

  const drawerEl = document.querySelector('#CartDrawer') || document.querySelector('cart-drawer');
  if (drawerEl) {
    const enAttr = drawerEl.getAttribute('data-milestone-enabled');
    if (enAttr !== null) {
      enabled = enAttr === 'true';
    }
    const vId = Number(drawerEl.getAttribute('data-gift-variant-id'));
    const tVal = Number(drawerEl.getAttribute('data-gift-threshold'));
    if (!isNaN(vId) && vId > 0) giftVariantId = vId;
    if (!isNaN(tVal) && tVal > 0) giftThreshold = tVal;

    const d1 = drawerEl.getAttribute('data-discount-code-1');
    const d2 = drawerEl.getAttribute('data-discount-code-2');
    if (d1) discountCode1 = d1;
    if (d2) discountCode2 = d2;
  }

  const bar = document.querySelector('[data-milestone-bar]');
  if (bar) {
    const vId = Number(bar.getAttribute('data-gift-variant-id'));
    const tVal = Number(bar.getAttribute('data-milestone-4'));
    if (!isNaN(vId) && vId > 0) giftVariantId = vId;
    if (!isNaN(tVal) && tVal > 0) giftThreshold = tVal;
  }

  return { enabled, giftVariantId, giftThreshold, discountCode1, discountCode2 };
}

async function checkMilestoneGift(cartData) {
  if (isMilestoneGiftSyncing) return;

  try {
    let cart = cartData;
    if (!cart || !Array.isArray(cart.items) || typeof cart.items_subtotal_price === 'undefined') {
      const res = await fetch((window.routes ? window.routes.cart_url : '/cart') + '.js', {
        headers: { Accept: 'application/json' },
      });
      cart = await res.json();
    }

    if (!cart || !Array.isArray(cart.items)) return;

    const { enabled, giftVariantId, giftThreshold, discountCode1, discountCode2 } = getMilestoneGiftConfig();
    if (!enabled || !giftVariantId) return;

    const giftItem = cart.items.find((item) => {
      const vId = Number(item.variant_id || (item.variant && item.variant.id) || item.id);
      const isMilestoneReward = item.properties && item.properties._milestone_reward === 'true';
      return vId === giftVariantId || isMilestoneReward;
    });
    const hasCurrentGift = giftItem && Number(giftItem.variant_id || (giftItem.variant && giftItem.variant.id) || giftItem.id) === giftVariantId;
    const hasAnyGift = !!giftItem;

    let qualifyingSubtotal = 0;
    cart.items.forEach((item) => {
      const vId = Number(item.variant_id || (item.variant && item.variant.id) || item.id);
      const isMilestoneReward = item.properties && item.properties._milestone_reward === 'true';
      if (vId !== giftVariantId && !isMilestoneReward) {
        qualifyingSubtotal += Number(item.final_line_price || (item.price * item.quantity));
      }
    });

    const qualifies = qualifyingSubtotal >= giftThreshold;
    const cartDrawer = document.querySelector('cart-drawer');
    const sectionsToRender = ['cart-drawer', 'cart-icon-bubble'];

    if (qualifies) {
      const appliedDiscounts = [];
      if (Array.isArray(cart.cart_level_discount_applications)) {
        appliedDiscounts.push(...cart.cart_level_discount_applications.map((d) => d.title));
      }
      if (Array.isArray(cart.discount_applications)) {
        appliedDiscounts.push(...cart.discount_applications.map((d) => d.title || d.code));
      }
      if (Array.isArray(cart.discount_codes)) {
        appliedDiscounts.push(...cart.discount_codes.map((d) => d.code));
      }

      const cleanTokens = [discountCode1, discountCode2]
        .filter(Boolean)
        .flatMap((s) => s.split(','))
        .map((t) => t.trim().toLowerCase().replace(/[\s\.\-_\u20B9]/g, ''))
        .filter(Boolean);

      const hasMatchingDiscount = appliedDiscounts.some((title) => {
        if (!title) return false;
        const cleanTitle = String(title).toLowerCase().replace(/[\s\.\-_\u20B9]/g, '');
        return cleanTokens.some((tok) => cleanTitle.includes(tok));
      });

      if (hasMatchingDiscount) {
        try {
          await fetch('/discount/CLEAR', { method: 'GET', redirect: 'manual' });
        } catch (_) {}
      }
    }

    if (qualifies && !hasCurrentGift) {
      isMilestoneGiftSyncing = true;
      if (giftItem && !hasCurrentGift) {
        await fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });
      }

      const addRes = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: giftVariantId,
              quantity: 1,
              properties: {
                _milestone_reward: 'true',
              },
            },
          ],
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      const result = await addRes.json();
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && result.sections) {
        cartDrawer.renderContents(result);
      }
    } else if (!qualifies && hasAnyGift) {
      isMilestoneGiftSyncing = true;
      const changeRes = await fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          id: giftItem.key || String(giftVariantId),
          quantity: 0,
          sections: sectionsToRender,
          sections_url: window.location.pathname,
        }),
      });

      const result = await changeRes.json();
      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && result.sections) {
        cartDrawer.renderContents(result);
      }
    }
  } catch (err) {
    console.error('Milestone gift auto-sync error:', err);
  } finally {
    isMilestoneGiftSyncing = false;
  }
}

window._cthCheckMilestoneGift = checkMilestoneGift;

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    checkMilestoneGift(event ? event.cartData : null);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => checkMilestoneGift());
} else {
  checkMilestoneGift();
}



/* ==========================================
   PRODUCT BASED GIFT MANAGER
   Independent from milestone gift
   Product B is a normal priced cart item
========================================== */

(function () {
  if (window.cthProductGiftInitialized) return;
  window.cthProductGiftInitialized = true;

  const configElement = document.getElementById(
    'cth-product-gift-config'
  );

  if (!configElement) return;

  let config;

  try {
    config = JSON.parse(configElement.textContent);
  } catch (error) {
    console.error('Gift config error:', error);
    return;
  }

  if (!config.enabled) return;

  const root = window.Shopify?.routes?.root || '/';
  const giftProperty = '_automatic_free_gift';

  let syncing = false;
  let syncPending = false;
  let syncTimer = null;

  // Remember removed gifts during this browser session.
  const dismissed = new Set();

  try {
    const saved = JSON.parse(
      sessionStorage.getItem('cth-dismissed-gifts') || '[]'
    );

    saved.forEach(id => dismissed.add(String(id)));
  } catch (_) {}

  function saveDismissed() {
    try {
      sessionStorage.setItem(
        'cth-dismissed-gifts',
        JSON.stringify([...dismissed])
      );
    } catch (_) {}
  }

  async function cartRequest(endpoint, payload) {
    const response = await fetch(root + endpoint, {
      method: payload ? 'POST' : 'GET',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      ...(payload ? { body: JSON.stringify(payload) } : {})
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(
        data.description || data.message || 'Cart error'
      );
    }

    return data;
  }

  function getCart() {
    return cartRequest('cart.js');
  }

  function getGiftItems(cart, offerId) {
    return cart.items.filter(item =>
      String(item.properties?.[giftProperty] || '') ===
      String(offerId)
    );
  }

 async function updateGiftApplyButton() {
  const button = document.getElementById('cth-coupon-apply');
  const input = document.getElementById('cth-coupon-input');

  if (!button || !input) return;

  if (button.getAttribute('aria-busy') === 'true') return;

  try {
    const cart = await getCart();

    const giftCode = String(
      config.reapplyCode || 'GIFTPACK'
    ).trim().toLowerCase();

    const enteredCode = input.value.trim().toLowerCase();

    const giftExists = cart.items.some(item =>
      item.properties?.[giftProperty]
    );

    const shouldDisable =
      giftExists && enteredCode === giftCode;

    button.disabled = shouldDisable;

    button.textContent = shouldDisable
      ? 'Gift Added ✓'
      : 'Apply';

    button.classList.toggle(
      'cth-gift-applied',
      shouldDisable
    );

  } catch (error) {
    console.error('Gift button update error:', error);
  }
}

  function getQualifyingQty(cart, offer) {
    return cart.items.reduce((total, item) => {
      // Do not count any automatically added gift.
      if (item.properties?.[giftProperty]) return total;

      if (
        offer.products.includes(Number(item.product_id))
      ) {
        return total + Number(item.quantity);
      }

      return total;
    }, 0);
  }

  async function addGift(offer) {
    return cartRequest('cart/add.js', {
      items: [{
        id: Number(offer.giftVariantId),
        quantity: 1,
        properties: {
          [giftProperty]: String(offer.id)
        }
      }]
    });
  }

  async function changeGift(item, quantity) {
    return cartRequest('cart/change.js', {
      id: item.key,
      quantity
    });
  }

  async function refreshDrawer() {
    const response = await fetch(
      root + '?sections=cart-drawer,cart-icon-bubble',
      { credentials: 'same-origin' }
    );

    if (!response.ok) return;

    const sections = await response.json();
    const parser = new DOMParser();

    if (sections['cart-drawer']) {
      const doc = parser.parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const nextInner = doc.querySelector(
        '#CartDrawer .drawer__inner'
      );

      const currentInner = document.querySelector(
        '#CartDrawer .drawer__inner'
      );

      if (nextInner && currentInner) {
        currentInner.innerHTML = nextInner.innerHTML;
      }
    document.addEventListener('input', event => {
  if (event.target.id === 'cth-coupon-input') {
    clearTimeout(couponDropdownTimer);

    couponDropdownTimer = setTimeout(
      updateGiftDropdown,
      150
    );

    updateGiftApplyButton();
  }
});
    }

    if (sections['cart-icon-bubble']) {
      const doc = parser.parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const nextBubble = doc.querySelector(
        '#cart-icon-bubble'
      );

      const currentBubble = document.querySelector(
        '#cart-icon-bubble'
      );

      if (nextBubble && currentBubble) {
        currentBubble.innerHTML = nextBubble.innerHTML;
      }
    }
  }

  
async function syncGifts() {
  if (syncing) {
    syncPending = true;
    return;
  }

  syncing = true;
  let changed = false;

  try {
    let cart = await getCart();

    const offers = config.offers.filter(offer =>
      offer.products?.length &&
      Number(offer.giftVariantId) > 0
    );

    // Find all qualifying offers.
    const eligibleOffers = offers.filter(offer =>
      getQualifyingQty(cart, offer) >=
      Number(offer.minimumQty || 1)
    );

    // Only one gift is allowed across all offers.
    // Offer 1 gets priority, then Offer 2.
    const selectedOffer = eligibleOffers[0] || null;

    const allGifts = cart.items.filter(item =>
      item.properties?.[giftProperty]
    );

    const selectedId = selectedOffer
      ? String(selectedOffer.id)
      : null;

    let keptGift = false;

    for (const gift of allGifts) {
      const giftOfferId = String(
        gift.properties[giftProperty]
      );

      const isSelected =
        selectedOffer &&
        giftOfferId === selectedId &&
        Number(gift.variant_id) ===
          Number(selectedOffer.giftVariantId) &&
        !keptGift;

      if (!isSelected) {
        await changeGift(gift, 0);
        changed = true;
        continue;
      }

      keptGift = true;

      if (gift.quantity !== 1) {
        await changeGift(gift, 1);
        changed = true;
      }
    }

    // Reset dismissed state when an offer
    // no longer qualifies.
    for (const offer of offers) {
      const qualifies = eligibleOffers.some(
        eligible => String(eligible.id) === String(offer.id)
      );

      if (!qualifies) {
        dismissed.delete(String(offer.id));
      }
    }

    saveDismissed();

    if (changed) {
      await refreshDrawer();
    }
    await updateGiftApplyButton();

  } catch (error) {
    console.error('Product gift sync error:', error);
  } finally {
    syncing = false;

    if (syncPending) {
      syncPending = false;
      scheduleSync();
    }
  }
}


  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncGifts, 250);
  }

  
/* ==========================================
   REMOVE PRODUCT B
========================================== */

document.addEventListener('click', async function(event) {
  const button = event.target.closest(
    '[data-product-gift-remove]'
  );

  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  if (button.disabled) return;

  const offerId = String(button.dataset.giftOffer || '');
  const itemKey = button.dataset.giftKey;

  if (!offerId || !itemKey) return;

  button.disabled = true;

  // Mark dismissed BEFORE cart mutation.
  dismissed.add(offerId);
  saveDismissed();

  try {
    await cartRequest('cart/change.js', {
      id: itemKey,
      quantity: 0
    });

    await refreshDrawer();

  } catch (error) {
    dismissed.delete(offerId);
    saveDismissed();

    console.error('Gift remove error:', error);
    button.disabled = false;
  }
}, true);


  // GIFTPACK re-add using existing coupon input.
  document.addEventListener('click', async event => {
    const button = event.target.closest(
      '#cth-coupon-apply'
    );

    if (!button) return;

    const input = document.getElementById(
      'cth-coupon-input'
    );

    const code = input?.value.trim();

    if (
      !code ||
      code.toLowerCase() !==
        String(config.reapplyCode || 'GIFTPACK')
          .trim()
          .toLowerCase()
    ) {
      return; // Let normal coupon handler process it.
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    const message = document.getElementById(
      'cth-coupon-message'
    );

   button.disabled = true;

const originalButtonHTML = button.innerHTML;

button.innerHTML = `
  <span class="cth-apply-loading">
    <span class="cth-apply-spinner"></span>
    Applying...
  </span>
`;

button.setAttribute('aria-busy', 'true');

if (message) {
  message.textContent = '';
  message.style.color = '';
}

    try {
      const cart = await getCart();

      const eligible = config.offers.filter(offer =>
        offer.products?.length &&
        Number(offer.giftVariantId) &&
        getQualifyingQty(cart, offer) >=
          Number(offer.minimumQty || 1)
      );

     if (!eligible.length) {
  if (message) {
    message.style.color = '#dc2626';
    message.textContent =
      'Add a qualifying product to use this gift code.';
  }
  return;
}

      
let added = 0;
let alreadyExists = 0;

// Allow only one gift across all eligible offers
const selectedOffer = eligible[0];

const giftAlreadyExists = cart.items.some(item =>
  item.properties?.[giftProperty] ||
  Number(item.variant_id) ===
    Number(selectedOffer.giftVariantId)
);

if (giftAlreadyExists) {
  alreadyExists = 1;
} else {
  const offerId = String(selectedOffer.id);

  dismissed.delete(offerId);
  saveDismissed();

  await addGift(selectedOffer);
  added = 1;
}

if (added > 0) {
  await refreshDrawer();

  const updatedMessage = document.querySelector(
    '#cth-coupon-message'
  );

  
if (updatedMessage) {
  updatedMessage.classList.remove('is-error');

  updatedMessage.textContent =
    'Gift product added successfully!';

  setTimeout(() => {
    if (
      updatedMessage.isConnected &&
      updatedMessage.textContent ===
        'Gift product added successfully!'
    ) {
      updatedMessage.textContent = '';
    }
  }, 3000);
}

} else if (alreadyExists > 0) {
  if (message) {
    message.textContent =
      'Gift product is already in your cart.';
  }
}


      // if (message) {
      //   message.textContent = 'Gift added successfully.';
      // }

    } catch (error) {
      if (message) {
        message.textContent = error.message;
      }
    }  finally {
  button.removeAttribute('aria-busy');

  if (button.isConnected) {
    button.innerHTML = originalButtonHTML;
    button.disabled = false;
  }

  await updateGiftApplyButton();
}
  }, true);

  // Listen to Dawn cart update events.
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }

  // Check whenever cart drawer opens.
  document.addEventListener('click', event => {
    if (event.target.closest('#cart-icon-bubble')) {
      scheduleSync();
    }
  });

  // Initial check.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleSync
    );
  } else {
    scheduleSync();
  }

  
/* =====================================
   GIFTPACK COUPON DROPDOWN
===================================== */

let couponDropdownTimer;

async function updateGiftDropdown() {
  const input = document.querySelector('#cth-coupon-input');
  const dropdown = document.querySelector('#cth-coupon-dropdown');
  const option = dropdown?.querySelector('[data-cth-gift-code]');

  if (!input || !dropdown || !option) return;

  const hide = () => {
    dropdown.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  };

  try {
    const cart = await getCart();

    const eligible = config.offers.some(offer =>
      offer.products?.length &&
      Number(offer.giftVariantId) > 0 &&
      getQualifyingQty(cart, offer) >=
        Number(offer.minimumQty || 1)
    );

    const alreadyAdded = cart.items.some(item =>
      item.properties?.[giftProperty]
    );

    const code = String(
      config.reapplyCode || 'GIFTPACK'
    ).trim();

    const matches =
      !input.value.trim() ||
      code.toLowerCase().includes(
        input.value.trim().toLowerCase()
      );

    const show = eligible && !alreadyAdded && matches &&
      document.activeElement === input;

    dropdown.hidden = !show;
    input.setAttribute('aria-expanded', String(show));

  } catch (error) {
    console.error('Gift dropdown error:', error);
    hide();
  }
}

document.addEventListener('focusin', event => {
  if (event.target.id === 'cth-coupon-input') {
    updateGiftDropdown();
  }
});

document.addEventListener('input', event => {
  if (event.target.id === 'cth-coupon-input') {
    clearTimeout(couponDropdownTimer);
    couponDropdownTimer = setTimeout(updateGiftDropdown, 150);
  }
});

document.addEventListener('click', event => {
  const option = event.target.closest('[data-cth-gift-code]');

  if (option) {
    event.preventDefault();

    const input = document.querySelector('#cth-coupon-input');
    const dropdown = document.querySelector('#cth-coupon-dropdown');

    if (input) {
      input.value = option.dataset.cthGiftCode;
      input.setAttribute('aria-expanded', 'false');
    }

    if (dropdown) dropdown.hidden = true;
    return;
  }

  if (!event.target.closest('.cth-coupon-input-wrap')) {
    const dropdown = document.querySelector('#cth-coupon-dropdown');
    const input = document.querySelector('#cth-coupon-input');

    if (dropdown) dropdown.hidden = true;
    if (input) input.setAttribute('aria-expanded', 'false');
  }
});

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    updateGiftApplyButton
  );
} else {
  updateGiftApplyButton();
}
  window.cthSyncProductGifts = scheduleSync;
})();
